/**
 * Client-side rate limiting for auth attempts.
 * 5 attempts per 60-second window.
 */
const MAX_ATTEMPTS = 5
const WINDOW_MS = 60 * 1000

let attempts = []

export function checkRateLimit() {
  const now = Date.now()
  // Remove expired attempts
  attempts = attempts.filter((t) => now - t < WINDOW_MS)

  if (attempts.length >= MAX_ATTEMPTS) {
    const oldestAttempt = attempts[0]
    const waitSeconds = Math.ceil((WINDOW_MS - (now - oldestAttempt)) / 1000)
    return { allowed: false, waitSeconds }
  }

  return { allowed: true, waitSeconds: 0 }
}

export function recordAttempt() {
  attempts.push(Date.now())
}
